import { useCallback, useState } from 'react';

import { NormalisedError } from '@utils/fetchRequest.ts';

export function useFetchRequest<TResponse>() {
  const [data, setData] = useState<TResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<NormalisedError | null>(null);

  const request = useCallback(async (fetchFn: () => Promise<TResponse>) => {
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const result: TResponse = await fetchFn();
      setData(result);
    } catch (error) {
      setError(error as NormalisedError);
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, error, request };
}

export default useFetchRequest;
